module.exports = __webpack_public_path__ + "static/media/Reference-Tse Melody-201230.docx.559d805b.pdf";